import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'clsx';

const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        // root: { width: 660, display: 'flex', justifyContent: 'center' },
        ratingContainer: {
            display: 'flex',
            justifyContent: 'center',
            [theme.breakpoints.down('xs')]: {
                flexWrap: 'wrap',
            },
        },
        ratingItem: {
            width: 58,
            height: 50,
            fontSize: 18,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 8,
            border: '1px solid #D5D7DD',
            marginRight: 8,
            cursor: 'pointer',
            [theme.breakpoints.down('md')]: {
                width: 45,
                height: 45,
            },
            [theme.breakpoints.down('sm')]: {
                width: 28,
                height: 33,
                // fontSize: 16,
                marginRight: 5,
            },
        },
        selected: {
            width: 58,
            height: 50,
            fontSize: 18,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 8,
            background: '#1D8A8B',
            color: '#FFFFFF',
            cursor: 'pointer',
            marginRight: 8,
            [theme.breakpoints.down('md')]: {
                width: 45,
                height: 45,
            },
            [theme.breakpoints.down('sm')]: {
                width: 28,
                height: 33,
                // fontSize: 16,
                marginRight: 5,
            },
        },
        unselected: {
            width: 58,
            height: 50,
            fontSize: 18,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 8,
            backgroundColor: '#F0F2F6',
            marginRight: 8,
            cursor: 'pointer',
            [theme.breakpoints.down('md')]: {
                width: 45,
                height: 45,
            },
            [theme.breakpoints.down('sm')]: {
                width: 28,
                height: 33,
                // fontSize: 16,
                marginRight: 5,
            },
        },
        valueTextContainer: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        valueText1: {
            marginLeft: '-8px',
        },
    }));
};

const AfitdRatingCounter = props => {
    const { isHidden, className, rating, setRating, lefttext, rightText, setIsDirty, ...otherProps } = props;
    const classes = useStyles({ props })();
    const ratingItems = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    const handleRating = item => {
        setRating(item);
        setIsDirty(true);
    };

    return isHidden ? null : (
        <div className={cx(classes.root, className)} {...otherProps}>
            <div className={cx(classes.ratingContainer, className)}>
                {ratingItems.map(item => (
                    <div key={item}>
                        {item === rating ? (
                            <div className={cx(classes.selected, className)} onClick={() => handleRating(item)}>
                                {item}
                            </div>
                        ) : item < rating ? (
                            <div className={cx(classes.unselected, className)} onClick={() => handleRating(item)}>
                                {item}
                            </div>
                        ) : (
                            <div className={cx(classes.ratingItem, className)} onClick={() => handleRating(item)}>
                                {item}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className={cx(classes.valueTextContainer, className)}>
                <div>
                    <p className={cx(classes.valueText1, className)}>{lefttext}</p>
                </div>
                <div>
                    <p>{rightText}</p>
                </div>
            </div>
        </div>
    );
};

export default AfitdRatingCounter;
